/**
 * Get the list of all loans for an establishment
 * @param {string} API_BASE - Base API URL
 * @param {string} token - JWT token
 * @param {string} code_etablissement - Establishment code
 * @returns {Promise<Array>} Array of loan objects
 */
async function getLoansList(API_BASE, token, code_etablissement) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/loansliste?code_etablissement=${code_etablissement}`, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(await response.text());
    }

    const loans = await response.json();
    //console.log("Loans list retrieved:", loans);

    return loans;
}

export default getLoansList;
